import { setActiveIndex } from "./activeIndex";
import { autoLoopMapHighlights } from "./autoLoopMapHighlights";
import { highlightActiveRoomsOnMap } from "./highlightActiveRoomsOnMap";
import { resetMapInterval } from "./mapInterval";
import { rememberMapTimeout, resetMapTimeout } from "./mapTimeout";
import { removeAllHighlights } from "./removeAllHighlights";
import { getRoomsRendered } from "./roomsRendered";
export function roomInteractions(e) {
    let target = e.target;
    const highlightTimeout = 1000 * 60; // 60 seconds
    while (target.nodeName != "BODY" && !target.classList.contains("room")) {
        target = target.parentNode;
    }
    if (target.classList.contains("room")) {
        target = document.querySelector(`[data-id="${target.dataset.id || target.id}"]`);
        const activeIndex = setActiveIndex(getRoomsRendered().indexOf(target));
        if (activeIndex > -1) {
            resetMapInterval();
            resetMapTimeout();
            removeAllHighlights();
            highlightActiveRoomsOnMap(activeIndex);
            // reset auto loop after about a minute
            // TODO: maintain activeIndex after reset?
            rememberMapTimeout(window.setTimeout(autoLoopMapHighlights, highlightTimeout));
        }
    }
}
